import React, { useState } from 'react';
import { Building2, LogOut, LifeBuoy } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { SupportModal } from '../pages/Landing';

const DashboardHeader = ({ rightContent }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showSupport, setShowSupport] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/dashboard')}>
          <Building2 className="w-8 h-8 text-[#EA580C]" />
          <span className="text-2xl font-bold text-[#0F172A]">RISTRUTTURA CASA ROMA</span>
        </div>
        <div className="flex items-center gap-3">
          {rightContent}
          <Button data-testid="dashboard-support-btn" onClick={() => setShowSupport(true)} variant="outline" size="sm" className="border-slate-300 text-slate-700 hover:bg-slate-50">
            <LifeBuoy className="w-4 h-4 mr-1" /> Supporto
          </Button>
          <div className="text-right">
            <p className="text-sm font-medium text-[#0F172A]">{user?.name}</p>
            <p className="text-xs text-slate-500 capitalize">{user?.role}</p>
          </div>
          <Button data-testid="logout-btn" onClick={handleLogout} variant="outline" size="sm" className="border-slate-300">
            <LogOut className="w-4 h-4" />
          </Button>
        </div>
      </div>
      <SupportModal open={showSupport} onClose={() => setShowSupport(false)} />
    </header>
  );
};

export default DashboardHeader;
